<template>
	<article class="cs-page" v-if="cs">
		<page-header :title="title" />
		<managing-section header="문의 정보" :column-count="2">
			<managing-box title="문의번호">{{ cs.cs_in.id }}</managing-box>
			<managing-box v-if="staticCode === 'CS_10'" title="회사명"
				>{{ cs.cs_in.company_name }}
			</managing-box>
			<managing-box v-else title="문의자" :horizontal-mode="true">
				<router-link
					class="link"
					:to="`/register/register-info/${cs.cs_in.register_id}`"
					target="_blank"
					v-if="cs.register.nickName"
					>{{ cs.register.nickName }}</router-link
				>
				<template v-else>
					<b class="cs__nonmember">비회원 </b>({{ cs.cs_in.email }})
				</template>
			</managing-box>
			<managing-box title="접수일">{{ cs.inCreatedAt }}</managing-box>
			<managing-box v-if="staticCode === 'CS_10'" title="브랜드명"
				>{{ cs.cs_in.brand_name }}
			</managing-box>
			<managing-box v-else title="기기정보" :no-padding="true">
				<table class="cs__device-info">
					<thead>
						<tr>
							<th>모델명</th>
							<th>OS_버전</th>
							<th>앱_버전</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>{{ cs.cs_in.app_meta_doc.device_model }}</td>
							<td>
								{{
									cs.cs_in.app_meta_doc.device_os ||
									cs.cs_in.app_meta_doc.os_version
								}}
							</td>
							<td>{{ cs.cs_in.app_meta_doc.app_version }}</td>
						</tr>
					</tbody>
				</table>
			</managing-box>
		</managing-section>
		<managing-section :splice="true">
			<managing-box v-if="staticCode === 'CS_10'" title="담당자 정보">{{
				`${cs.cs_in.name} (${cs.cs_in.contact} / ${cs.cs_in.email})`
			}}</managing-box>
			<managing-box v-else title="문의유형">
				<template v-if="cs.cs_in.state && staticCode === 'CS_10'">{{
					staticCodeName
				}}</template>
				<select class="select" v-else v-model="staticCodeSelect">
					<option
						v-for="item in staticCodeList"
						:key="item.code"
						:value="item.code"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
			<managing-box title="문의내용">
				<pre class="cs__in-body">{{ cs.cs_in.body }}</pre>
			</managing-box>
			<ManagingBox title="유입 경로 및<br>기타 사유">
				<p v-if="cs.cs_in.contact_channel">
					유입 경로:&nbsp{{ cs.contactChannel }}
				</p>
				<div
					v-if="contactChannelEtc"
					class="cs-page__contact-channel-etc"
				>
					<p>기타 사유:&nbsp</p>
					<pre>{{ contactChannelEtc }}</pre>
				</div>
			</ManagingBox>
			<managing-box
				v-if="staticCode !== 'CS_10'"
				title="첨부이미지<br>(클릭 시 확대)"
				:horizontal-mode="true"
			>
				<template v-if="cs.cs_in_attaches.length">
					<img
						class="cs__img"
						v-for="item in cs.cs_in_attaches"
						@click="
							showOriginImg(`${IMAGE_STORAGE_PATH}${item.path}`)
						"
						:key="item.id"
						:src="`${IMAGE_STORAGE_PATH}${item.path}`"
					/>
				</template>
				<p class="disabled-text" v-else>첨부된 이미지가 없습니다.</p>
			</managing-box>
		</managing-section>
		<managing-section header="답변 정보" :column-count="2">
			<managing-box title="답변상태">
				<b>{{
					cs.cs_in.state === '답변완료'
						? '완료'
						: cs.cs_in.state || '대기'
				}}</b>
			</managing-box>
			<managing-box title="답변일">
				{{ parseDate(cs.cs_out.created_at) }}
			</managing-box>
		</managing-section>
		<managing-section v-if="staticCode !== 'CS_10'" :splice="true">
			<managing-box title="답변내용">
				<textarea ref="body" v-model="body" rows="10"></textarea>
			</managing-box>
		</managing-section>
		<ol class="cs__desc" v-if="staticCode !== 'CS_10'">
			<li class="cs__desc__item">
				<span class="cs__desc__highlight">[회원]</span> 답변 알림 : Push
				+ 알림함 발송 / 답변 확인 : [설정>고객지원>1:1문의]에서 확인
				가능합니다.
			</li>
			<li class="cs__desc__item">
				<span class="cs__desc__highlight">[비회원]</span> 답변 알림 :
				없음 / 답변 확인 : 문의시 작성한 이메일에서 확인 가능합니다.
			</li>
			<li class="cs__desc__item">
				<span class="cs__desc__highlight">[회원/비회원]</span> 최초 답변
				등록 후 [수정]시, 사용자에게 별도의 알림이 발송되지 않으며,
				수정한 답변 내용은 저장됩니다.
			</li>
		</ol>
		<div
			class="btn-wrap-main"
			v-if="!(cs.cs_in.state && staticCode === 'CS_10')"
		>
			<button class="btn-main" v-if="cs.cs_in.state" @click="modifyCs">
				수정
			</button>
			<button
				class="btn-main blue"
				v-else-if="staticCode === 'CS_10'"
				@click="completeCs"
			>
				완료
			</button>
			<template v-else>
				<button class="btn-main" @click="initCs">초기화</button>
				<button class="btn-main blue" @click="completeCs">등록</button>
			</template>
		</div>
		<managing-section>
			<managing-box title="메모">
				<memo-box ref-type="cs_in" :ref-id="Number(csId)" />
			</managing-box>
		</managing-section>
	</article>
</template>
<script>
	import { contactChannelList } from '@/constants.js';
	import util from '@/util.js';
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import MemoBox from '@/components/MemoBox.vue';

	export default {
		name: 'Cs',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			MemoBox,
		},
		data() {
			return {
				csId: null,
				csOutId: null,
				staticCode: '',
				title: '',
				cs: null,
				staticCodeName: '',
				staticCodeSelect: '',
				body: '',
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
			...mapGetters({
				staticCodeList: 'csStaticCodeList',
			}),
			contactChannelEtc() {
				const contactChannel = this.cs?.cs_in?.contact_channel;
				return contactChannel &&
					contactChannelList.every(
						item => item.value !== contactChannel
					)
					? contactChannel
					: '';
			},
		},
		created() {
			this.setPage();
		},
		mounted() {
			this.setData();
		},
		methods: {
			showOriginImg(path) {
				util.popupImages([path], 500);
			},
			parseDate(
				date,
				format = 'YYYY.MM.DD HH:mm:ss',
				defaultValue = '-'
			) {
				return date ? moment(date).format(format) : defaultValue;
			},
			setPage() {
				this.csId = this.$route.params.csId;
				const code = this.$route.query.staticCode;
				const codeList = this.staticCodeList;
				this.staticCode = codeList.some(item => item.code === code)
					? code
					: codeList[0].code;
				if (code === 'CS_10') {
					const title = '광고/제휴 문의';
					document.title = title;
					this.title = title;
				}
			},
			getContactChannelTxt(contactChannel) {
				return contactChannel
					? contactChannelList.find(
							item => item.value === contactChannel
						)?.label ||
							contactChannelList[contactChannelList.length - 1]
								.label
					: '';
			},
			async setData() {
				try {
					const { data } = await this.$axiosSupport.get(
						`/admin/cs/${this.csId}`
					);
					this.csOutId = data.cs_out.id;
					this.cs = {
						...data,
						inCreatedAt: this.parseDate(data.cs_in.created_at),
						contactChannel: this.getContactChannelTxt(
							data.cs_in.contact_channel
						),
					};
					this.staticCodeSelect = data.cs_in.static_code;
					this.staticCodeName = this.staticCodeList.filter(
						item => item.code === data.cs_in.static_code
					)[0].name;
					this.body = data.cs_out.body;
				} catch (err) {
					if (err.response.status === 404) {
						alert('고객 요청에 의해 문의가 삭제되었습니다.');
					} else {
						const message =
							err.response.data.error.message ||
							'문의 정보를 가져오는 동안 문제가 발생했습니다\n문제가 지속될 경우 개발팀에 문의해 주세요';
						alert(message);
					}

					console.error(err);

					await this.$router.push({
						path: '/operation/cs-list',
					});
				}
			},
			initCs() {
				if (!confirm('답변 내용을 전체 초기화 하시겠어요?')) return;
				this.body = '';
				this.staticCodeSelect = this.cs.cs_in.static_code;
			},
			historyBack() {
				if (document.referrer.indexOf('/operation/cs-list') > -1) {
					this.$router.go(-1);
				} else {
					this.$router.push('/operation/cs-list');
				}
			},
			async modifyCs() {
				if (this.staticCode !== 'CS_10' && !this.body) {
					alert('답변내용을 입력해주세요.');
					this.$refs.body.focus();
					return;
				}
				if (
					!confirm(
						'수정된 내용은 회원에게 별도의 알림이 발송되지 않습니다. 그래도 수정된 정보로 저장하시겠어요?'
					)
				)
					return;
				const params = {
					cs_in: {
						static_code: this.staticCodeSelect,
					},
					cs_out: {
						body: this.body,
					},
				};
				await this.$axiosSupport.put(
					`/admin/cs/${this.csId}/out/${this.csOutId}`,
					params
				);
				this.historyBack();
			},
			async completeCs() {
				if (this.staticCode !== 'CS_10' && !this.body) {
					alert('답변내용을 입력해주세요.');
					this.$refs.body.focus();
					return;
				}
				if (
					!confirm(
						'답변 등록 후, 답변 내용은 수정할 수 없습니다. 답변을 등록하시겠습니까?'
					)
				)
					return;
				const params = {
					cs_in: {
						static_code: this.staticCodeSelect,
					},
					cs_out: {
						created_at: moment(new Date()).utcOffset(0).format('YYYY-MM-DD HH:mm:ss'),
						body: this.body,
					},
				};
				await this.$axiosSupport.post(
					`/admin/cs/${this.csId}/out`,
					params
				);
				this.historyBack();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.cs__nonmember {
		margin-right: 8px;
	}

	.cs__device-info {
		th,
		td {
			padding: 8px;
			border: solid 1px #dfe6ee;
		}

		th {
			background: #f4f7fa;
			border-top: 0;
		}

		tbody td {
			border-bottom: 0;
		}

		th:first-child,
		td:first-child {
			border-left: 0;
		}

		th:last-child,
		td:last-child {
			border-right: 0;
		}
	}

	.cs__in-body {
		background-color: transparent;
		white-space: break-spaces;
	}

	.cs__img {
		cursor: pointer;
		max-width: 80px;
		max-height: 80px;
		margin-right: 14px;
	}

	.cs__desc {
		margin-top: 40px;
		padding-left: 14px;
	}

	.cs__desc__item {
		line-height: 20px;
	}

	.cs__desc__highlight {
		color: $font-blue;
	}

	.cs-page {
		&__contact-channel-etc {
			display: flex;
			align-items: flex-start;
			margin-top: 8px;
		}
	}
</style>
